import React from "react";
import { CheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { finalIncluded } from "../../data/sections";
const needs = ["Where to look.", "What to do.", "What comes next.", "And what to record."];
export function FinalCtaSection() {
  return <section className="bg-brand-dark px-5 py-16 sm:py-24" data-id="element-148" data-mp="2dik24o84zkgo">
      <div className="mx-auto max-w-3xl text-center" data-id="element-149" data-mp="2riuu5ul6n53f">
        <h2 className="font-serif text-[2rem] font-extrabold leading-[1.12] text-cream sm:text-5xl" data-id="element-150" data-mp="2rhjnnn0crj8m">
          Are you ready to stop searching and <em className="text-[#F2B79F]" data-id="element-151" data-mp="318xu6eqq1jb9">start practicing with a system?</em>
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-cream/80" data-id="element-152" data-mp="31asaffr1sn90">
          You don't need another forgotten file buried inside a folder. You don't need to study everything again every time you want to practice. You need to know:
        </p>
        <ul className="mt-6 space-y-1" data-id="element-153" data-mp="369241lx4jfsi">
          {needs.map(n => <li key={n} className="font-serif text-2xl font-bold uppercase text-cream sm:text-3xl" data-id="element-154" data-mp="220ui2q4hm9fz">{n}</li>)}
        </ul>

        <ul className="mx-auto mt-10 grid max-w-xl gap-2.5 text-left sm:grid-cols-2" data-id="element-155" data-mp="2637ozhuz0dec">
          {finalIncluded.map(item => <li key={item} className="flex items-center gap-2.5 text-[16px] font-semibold text-cream" data-id="element-156" data-mp="2b3c4p5o2143i">
              <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-cream text-brand" data-id="element-157" data-mp="2fy9c685or5ea">
                <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-158" data-mp="2kxm7lhamhksh" />
              </span>
              {item}
            </li>)}
        </ul>

        <p className="mt-10 text-base text-cream/80" data-id="element-159" data-mp="2tsae1arxp8iv">
          Organize your practice. Reference your materials. Follow a clear structure. Track your progress.
        </p>
        <p className="mt-6 text-sm font-extrabold uppercase tracking-wider text-cream/80" data-id="element-160" data-mp="33qpumjtc4ze4">Just</p>
        <p className="font-serif text-[5.5rem] font-extrabold leading-none text-cream sm:text-[7rem]" data-id="element-161" data-mp="38o86oj2nfuqc">$27</p>
      </div>

      <CTAButton tone="dark" label="Yes! I want Reflexology Session Blueprint™" className="mt-8" data-id="element-162" data-mp="2j1nlba2wxv9w" />
      <Countdown tone="dark" className="mt-9" data-id="element-163" data-mp="2e33uowddjvb7" />
      <p className="mt-6 text-center text-base font-semibold text-cream" data-id="element-164" data-mp="2sqp04wxq26ma">
        Get Reflexology Session Blueprint™ today and receive all 5 bonuses FREE.
      </p>
    </section>;
}